import { useCallback, useRef } from 'react';
import type { FlatListProps } from 'react-native';
import { bridge, isNil } from 'shared/src/utils';
import type { MarketRankingItem } from 'shared/src/api';

type ListItem =
  | { type: 'filter' }
  | { type: 'market'; data: MarketRankingItem };

export const useLogDisplayMarket = () => {
  const loggedMarketSnosRef = useRef<Set<number>>(new Set());

  return useCallback<
    NonNullable<FlatListProps<ListItem>['onViewableItemsChanged']>
  >(({ viewableItems }) => {
    viewableItems.forEach(({ isViewable, item }) => {
      if (!isViewable) return;
      if (item.type !== 'market') return;

      const market = item.data;
      if (loggedMarketSnosRef.current.has(market.sno)) return;
      if (isNil(market.market_type?.name)) return;

      loggedMarketSnosRef.current.add(market.sno);

      bridge.logAnalyticsEvent({
        channel: ['ablylog', 'firebase'],
        name: 'DISPLAY_MARKET',
        analytics: {
          SCREEN: 'MARKET_RANKING',
          MARKET_SNO: market.sno.toString(),
          MARKET_TYPE: market.market_type.name,
        },
      });
    });
  }, []);
};